import { forwardRef } from "react";
import { PropertyRow } from "../PropertyUpdateRowInput";

export const CustomUpdateInput = forwardRef(
  ({ field, settings, onRemove, ...rest }, ref) => {
    return (
      <PropertyRow
        key={field}
        field={field}
        label={settings?.headerText}
        onRemove={onRemove}
        showRemoveButtonOnTop
        settings={settings}
      >
        {settings.component && (
          <settings.component
            field={field}
            remove={onRemove}
            ref={ref}
            settings={settings}
            {...rest}
          />
        )}
        {settings.template?.(
          { field: field, remove: onRemove, settings: settings, ...rest },
          ref
        )}
      </PropertyRow>
    );
  }
);
